import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/commerceimport`,
  timeout: 60000,
});

/** 供 App 初始化逾時（appsettings ImportSql） */
export { api as commerceImportHttp };

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      const loginPath = localStorage.getItem('adminLoginPath') || '/';
      window.location.href = loginPath;
    }
    return Promise.reject(error);
  }
);

export const commerceImportApi = {
  // --- Data Loading ---
  uploadExcelFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/upload-excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  loadFromExcel: async (config) => {
    const response = await api.post('/load-from-excel', config);
    return response.data;
  },

  uploadGoogleSheetsUrl: async (url) => {
    const response = await api.post('/upload-google-sheets', { url });
    return response.data;
  },

  loadFromGoogleDocs: async (config) => {
    const response = await api.post('/load-from-google-docs', config);
    return response.data;
  },

  testSqlConnection: async (config) => {
    const response = await api.post('/test-sql-connection', config);
    return response.data;
  },

  loadFromSql: async (config) => {
    const response = await api.post('/load-from-sql', config);
    return response.data;
  },

  // --- Execute Import ---
  executeImport: async (targetEntity, rows, companyId) => {
    const response = await api.post('/execute', { targetEntity, rows, companyId });
    return response.data;
  },

  // --- WPA Import ---
  wpaImport: async (targetKind, rows, allowPasswordUpdate = false) => {
    const response = await api.post('/wpa-import', { targetKind, rows, allowPasswordUpdate });
    return response.data;
  },

  // --- Sales Order Export ---
  exportSalesOrders: async (params) => {
    const response = await api.post('/sales-orders/export', params);
    return response.data;
  },

  // --- Schedule CRUD ---
  createSchedule: async (data) => {
    const response = await api.post('/schedule', data);
    return response.data;
  },

  getSchedules: async (params = {}) => {
    const response = await api.get('/schedule', { params });
    return response.data;
  },

  updateSchedule: async (id, data) => {
    const response = await api.put(`/schedule/${id}`, data);
    return response.data;
  },

  deleteSchedule: async (id) => {
    const response = await api.delete(`/schedule/${id}`);
    return response.data;
  },

  updateScheduleStatus: async (id, statusData) => {
    const response = await api.put(`/schedule/${id}/status`, statusData);
    return response.data;
  },

  executeSchedule: async (id) => {
    const response = await api.post(`/schedule/${id}/execute`);
    return response.data;
  },

  getScheduleImportProgress: async (id) => {
    const response = await api.get(`/schedule/${id}/import-progress`);
    return response.data;
  },
};

export default commerceImportApi;
